import {
  GET_ALL,
  GET_ALL_FAILURE,
  GET_ALL_SUCCESS,
  ADD,
  ADD_FAILURE,
  ADD_SUCCESS,
  DELETE,
  DELETE_FAILURE,
  DELETE_SUCCESS,
  EDIT,
  EDIT_FAILURE,
  EDIT_SUCCESS,
  GET,
  GET_FAILURE,
  GET_SUCCESS,
} from "./actionTypes";

export const getAllWebhooks = (payload) => {
  return {
    type: GET_ALL,
    payload: payload,
  };
};
export const getAllWebhooksSuccess = (payload) => {
  return {
    type: GET_ALL_SUCCESS,
    payload: payload,
  };
};

export const getAllWebhooksFailure = (error) => {
  return {
    type: GET_ALL_FAILURE,
    payload: error,
  };
};

export const addWebhook = (payload) => {
  return {
    type: ADD,
    payload: payload,
  };
};
export const addWebhookSuccess = (payload) => {
  return {
    type: ADD_SUCCESS,
    payload: payload,
  };
};

export const addWebhookFailure = (error) => {
  return {
    type: ADD_FAILURE,
    payload: error,
  };
};

export const getWebhook = (payload) => {
  return {
    type: GET,
    payload: payload,
  };
};
export const getWebhookSuccess = (payload) => {
  return {
    type: GET_SUCCESS,
    payload: payload,
  };
};

export const getWebhookFailure = (error) => {
  return {
    type: GET_FAILURE,
    payload: error,
  };
};

export const editWebhook = (payload) => {
  return {
    type: EDIT,
    payload: payload,
  };
};
export const editWebhookSuccess = (payload) => {
  return {
    type: EDIT_SUCCESS,
    payload: payload,
  };
};

export const editWebhookFailure = (error) => {
  return {
    type: EDIT_FAILURE,
    payload: error,
  };
};

export const deleteWebhook = (payload) => {
  return {
    type: DELETE,
    payload: payload,
  };
};

export const deleteWebhookSuccess = (payload) => {
  return {
    type: DELETE_SUCCESS,
    payload: payload,
  };
};

export const deleteWebhookFailure = (error) => {
  return {
    type: DELETE_FAILURE,
    payload: error,
  };
};
